import { ReactNode, createContext, useState } from 'react'
import { useRouter } from 'next/router'

import { PreLeadFormData } from '@components/v2/SimulationBanner/components/Steps/PreLead'
import { Lead } from '../types/lead'

export type Step = 'simulação' | 'endereço' | 'resumo' | 'finished'

export interface Monthly {
  power: number
  name: string
}

export interface SummaryData {
  panels_power: string
  panels_amount: number
  required_area: string
  required_power: string
  monthly_production: string
  annual_savings: string
  monthly: [string] | Monthly[]
  payback: number
  estimated_generator_cost_min: string
  estimated_generator_cost_max: string
}

type PreLeadData = PreLeadFormData & {
  simulationId: number
}

type CalculatorSolarType = {
  steps: Step[]
  currentStep: Step
  handleCurrentStep: (step: Step) => void
  summaryData: SummaryData
  handleSummaryData: (data: SummaryData) => void
  preLeadData: PreLeadData
  leadData: Lead
  handlePreLeadData: (data: PreLeadData) => void
  handleLeadData: (data: Lead) => void
  handleResetSimulation: () => void
}

interface CalculatorSolarProps {
  children: ReactNode
}

export const CalculatorSolarContext = createContext({} as CalculatorSolarType)

export function CalculatorSolarProvider({ children }: CalculatorSolarProps) {
  const [steps, setSteps] = useState<Step[]>([
    'simulação',
    // 'endereço',
    'resumo',
    'finished'
  ])
  const [currentStep, setCurrentStep] = useState<Step>('simulação')
  const [summaryData, setSummaryData] = useState<SummaryData>()
  const [preLeadData, setPreLeadData] = useState<PreLeadData>()
  const [leadData, setLeadData] = useState<Lead>()

  const router = useRouter()

  function handleCurrentStep(step: Step) {
    setCurrentStep(step)
  }

  async function handleResetSimulation() {
    // Usa asPath para obter o caminho real (não o padrão com [category]/[...slugs])
    const pathWithoutQuery = router.asPath.split('?')[0]
    await router.push(pathWithoutQuery, undefined, { scroll: false })

    setCurrentStep('simulação')
    setSummaryData(null)
    setPreLeadData(null)
    setLeadData(null)
  }

  function handleSummaryData(data: SummaryData) {
    setSummaryData(data)
  }

  function handlePreLeadData(data: PreLeadData) {
    setPreLeadData(data)
  }

  function handleLeadData(data: Lead) {
    setLeadData(data)
  }

  return (
    <CalculatorSolarContext.Provider
      value={{
        steps,
        currentStep,
        handleCurrentStep,
        summaryData,
        handleSummaryData,
        preLeadData,
        handlePreLeadData,
        leadData,
        handleLeadData,
        handleResetSimulation
      }}
    >
      {children}
    </CalculatorSolarContext.Provider>
  )
}
